import React, { useState } from "react";
import axios from "axios";
const Form = () => {
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [success, setSuccess] = useState("");
  const [failure, setFailure] = useState("");
  const onSubmit = (e) => {
    e.preventDefault();
    if (!name) {
      alert("Please enter your name in the name field.");
    } else if (!email) {
      alert("Please enter your email in the email field.");
    } else if (!validateEmail(email)) {
      alert(`${email} is not a valid email`);
    }

    const formData = {};

    formData["EMAIL"] = email;
    formData["NAME"] = name;

    axios
      .post("https://api.ruhacks.com/signup", { formData })
      .then((res) => {
        setSuccess("Success!");
        setFailure("");
      })
      .catch((res) => {
        setFailure("Error!");
        setSuccess("");
      });
  };
  return (
    <div className="footer-ab__form faf">
      <div className="faf-title">Sign up for our newsletter!</div>
      <div>
        <input
          className="faf-txtbox name"
          type="text"
          id="sign_newsl_2"
          placeholder="Enter First Name"
          name="NAME"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          className="faf-txtbox email"
          type="text"
          id="sign_newsl_1"
          placeholder="Enter Email"
          name="EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          // disabled={email === "" || name === "" || !validateEmail(email)}
          className="faf-submit"
          type="submit"
          value="Submit"
          onClick={onSubmit}
        />
      </div>
      <p className="faf-sucessText">{success}</p>
      <p className="faf-failureText">{failure}</p>
    </div>
  );
};
export default Form;
